<template>
  <div class="foot-menu"><div class="foot-menu-content"
                              :class="globalTransition">
    <div class="left">
      <div class="title"> {{$t('contact.title')}}</div>
      <div class="content">
        <div>{{$t('contact.company')}}</div>
        <div>{{$t('contact.address')}}</div>
        <div>{{$t('contact.city')}}</div>
        <div>{{$t('contact.phone')}}</div>
        <div>{{$t('contact.email')}}</div>
      </div>
    </div>
    <div class="right">
      <template v-for="event in mainMenu"><div v-if="event.child!==false"  :key="event.name"
                                               class="menu-content">
        <a class="title" @click="handleClick(event)"> {{$t( 'mainMenu.' + event.name)}}</a>
        <div class="content" v-for="events in getCurrentMenu(event.name)" :key="events.name">
          <a @click="handleClick(events)">{{$t(event.name+'.'+events.name)}}</a>
        </div>
      </div></template>
    </div>
  </div><div class="copyright" :class="globalTransition">
    <div class="copyright">{{$t('copyright.copyright')}}</div>
    <div class="law">{{$t('copyright.law')}}
      <a href="javascript:void(0)">{{$t('copyright.lawLink')}}</a></div>
  </div></div>

</template>

<script>
export default {
  name: 'footMenu',
  data() {
    return {
      mainMenu: [
        { name: 'homePage', root: '/', route: '/', child: false },
        { name: 'about', root: 'about', route: 'about', child: 'about' },
        { name: 't$e', root: 't$e', route: 't$e', child: 't$e' },
        { name: 'p$s', root: 'p$s', route: 'p$s', child: 'p$s' },
        { name: 'contact', root: 'contact', route: 'contact', child: false },
      ],
      about: [
        { name: 'aboutDIMER', root: 'about', route: 'aboutDetailPage', child: false },
        { name: 'DIMER_BOARD', root: 'about', route: 'aboutBoardPage', child: false },
        /* { name: 'm$c', root: 'about', route: 'aboutCommitteePage', child: false }, */
        { name: 'a$r', root: 'about', route: 'aboutAwardPage', child: false },
        { name: 'latestNews', root: 'about', route: 'aboutDetailPage', child: false },
      ],
      t$e: [
        { name: 'gasProcessTech', root: 't$e', route: 'gasProcessTech', child: false },
        { name: 'ptgTech', root: 't$e', route: 'ptgTech', child: false },
        { name: 'cleanEnergyDev', root: 't$e', route: 'cleanEnergyDev', child: false },
      ],
      p$s: [
        { name: 'h2ch4Rec$co2Capt', root: 'p$s', route: '1h2ch4Rec$co2Capt', child: false },
        { name: 'renewablePower', root: 'p$s', route: '2renewablePower', child: false },
        { name: 'co2Sep$Capt', root: 'p$s', route: '3co2Sep$Capt', child: false },
        { name: 'co2Capt$reuse', root: 'p$s', route: '4co2Capt$reuse', child: false },
        { name: 'wasteWaterTreat', root: 'p$s', route: '5wasteWaterTreat', child: false },
      ],
    };
  },
  computed: {
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
  watch: {
    globalTransition() {
      this.doTransition = !this.doTransition;
    },
  },
  methods: {
    getCurrentMenu(name) {
      return this[name];
    },
    handleClick(event) {
      this.$router.push({
        path: event.root,
        query: {
          anchor: event.route,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .foot-menu{
    height: auto;
    background-color: #000;
    padding: 6rem 6.7%;
  }
.foot-menu-content{
  display: flex;
  width: 100%;
  .left{
    width: 40%;
  }
  .right{
    width: 60%;
    display: flex;
    justify-content: space-around;
    .menu-content{
      display: flex;
      flex-direction: column;
      width: 33%;
    }
  }
}
  .title {
    color: #369ff6;
    font-size: 1.5rem;
    font-weight: bold;
    max-width: 60%;
    word-break: break-word;
    height: 5rem;
  }
  .content{
    color: #fff;
    font-size: 1rem;
    line-height: 2rem;
  }
  .content:hover{
    a{text-decoration:underline}
  }
  .copyright{
    width: 100%;
    margin-top: 30px;
    color: #555;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    white-space: nowrap;
    a{text-decoration:underline}
  }
</style>



// WEBPACK FOOTER //
// src/components/footMenu/index.vue